export const Region = {
  MALAYSIA: "MY",
  INDO: "ID",
};

export const hideCompanyList = [
  "joker",
  "playtech",
  "ebet",
  "allbet",
  "dreamgaming",
  "evolutiongaming",
];

export const malaysiaDatabaseName = "ok99MemberMYR";
